import type { Request } from '@/types/Request';
import { CloudflareIPGeoData } from '@/types/CloudflareIPGeoData';

export const getCfGeoFromReq = (req: Request): CloudflareIPGeoData => {
  return {
    connecting_ip: req.headers?.['cf-connecting-ip'] || null,
    city: req.headers?.['cf-ipcity'] || null,
    continent: req.headers?.['cf-ipcontinent'] || null,
    country: req.headers?.['cf-ipcountry'] || null,
    latitude: req.headers?.['cf-iplatitude'] || null,
    longitude: req.headers?.['cf-iplongitude'] || null,
    metro_code: req.headers?.['cf-metro-code'] || null,
    postal_code: req.headers?.['cf-postal-code'] || null,
    region: req.headers?.['cf-region'] || null,
    region_code: req.headers?.['cf-region-code'] || null,
    timezone: req.headers?.['cf-timezone'] || null,
  };
};
